import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        // 获取抵扣顺序下拉列表
        getInitData() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 1000,
            };
            this.accountTypes = [];

            this.loading = true; //拼命加载中显示
            $http.get('api/Memorandum/GetMemorandumDeductible_List', params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {

                    this.accountTypes = Data
                    this.loading = false; //拼命加载中隐藏
                });
            });
        },
        // 获取套餐列表
        getPackageData() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 1000,
                ParmType: 101
            };
            this.PackageTypes = [];

            this.loading = true; //拼命加载中显示
            $http.get('api/Common/GetParmConfig', params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {

                    this.PackageTypes = Data
                    this.loading = false; //拼命加载中隐藏


                });
            });
        },
        // 修改套餐规则
        getPackageRuleData(id) {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: id
            };
            this.loading = true; //拼命加载中显示
            $http.get('api/Memorandum/GetMemorandumById', params).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.submitFormData = $.extend({}, this.submitFormData, Data);

                    this.submitFormData.PackageId = this.submitFormData.PackageId.toString()

                    if (this.submitFormData.DeductibleOrder !== null) {
                        if (this.submitFormData.DeductibleOrder.length > 0) {
                            // 
                            for (let i = 1; i < this.submitFormData.DeductibleOrder.length; i++) {
                                this.isDelBtnShow.push(true); //删除按钮
                                this.isAddBtnShow.unshift(false); //新增按钮
                            }
                        }
                    }

                    this.loading = false; //拼命加载中隐藏
                });
            });
        },
        // 添加事件类型
        submitMatter() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            let query = {}
            query.MatterTypeName = this.MatterTypeName
            params = Object.assign({}, params, query);
            $http.post('api/Bing/ERP_MatterTypeAdd', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.MatterVisible = false
                    this.getInitData();
                });
            });
        },
        // 提交添加特殊事项
        submitPackageRule(data) {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            params = Object.assign({}, params, data);
            let $href = 'api/Memorandum/ERP_MemorandumAdd';
            let msg = ''
            if (this.isChange) {
                $href = 'api/Memorandum/ERP_MemorandumUpdate'
                msg = '修改成功'
            } else {
                $href = 'api/Memorandum/ERP_MemorandumAdd'
                msg = '添加成功'
            }
            $http.post($href, params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: msg,
                        type: 'success'
                    });
                    this.dialogClose();
                    this.$emit('reLoadList')
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Memorandum/PackageRule/components/addPackageRule/services.js